module.exports = __webpack_public_path__ + "img/rejdoffer.776378d1.svg";